<template>
	<div class="text-center">
		<h2>404: Page not found.</h2>
		<router-link :to="{ name: 'home' }">
			Go back to home
		</router-link>
	</div>
</template>
